import { setDocumentTitle } from "@/lib/documentTitle";
// src/features/legacy-quantilia/issuer_events/main.tsx

import { useEffect } from "react";
import type { ReactElement } from "react";
import { Route, Routes } from "react-router-dom";
import { IssuerEventsCard } from "./card";

import { IssuerEventsTable } from "./table";

export default function IssuerEvent(): ReactElement {
  useEffect(() => {
    setDocumentTitle("Quantilia | Événements des émetteurs");
  }, []);

  return (
    <Routes>
      <Route index element={<IssuerEventsTable />} />

      <Route path=":id" element={<IssuerEventsCard />} />
    </Routes>
  );
}
